/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для товара в корзине
   */
  app.CartItem = app.Model.extend({

    defaults: {
      qty: '',
      cart_id: 'main'
    },

    idAttribute: 'item_id',

    url: app.entryScriptName + '/api/v3/cart-item/',
    run: function (attrs, options) {
      if (options && options.item) {
        this.set('item', options.item);
      }
    },

    parse: function (resp) {
      Backbone.trigger('update-cart-info', {cartInfo: resp._cart});
      if (resp['_paid-delivery']) {
        Backbone.trigger('update-paid-delivery', {paidDelivery: resp['_paid-delivery']});
      }
      if (resp._volume_discount && resp._wholesale) {
        Backbone.trigger('update-discount', {discount: this.getDiscountData(resp)});
      }
      if (resp._meta && resp._meta.gifts) {
        Backbone.trigger('gift-deleted-from-cart', resp._meta.gifts);
      }
      return resp;
    },

    /**
     * Проверяет, является ли товар транзитом, недоступным для доставки в город.
     * @param {number} settlementId id текущего города.
     * @returns {boolean} Булево значение.
     */
    isDisabledTransit: function (settlementId) {
      var transitSettlements = this.get('item') && this.get('item').transit_in_settlement;
      return transitSettlements
        && transitSettlements.length
        && transitSettlements.indexOf(settlementId) === -1;
    },
  });

  _.extend(app.CartItem.prototype, app.CartDiscountMixin);

})();

}.call(window));